<template>
    <div class="dashboard__entity-charts">
        <div class="card card--with-heading data-chart-comparison">
            <h4>
                Semana de entrega Ofrecido / Concretado
                <DashboardFilters
                    ref="filtersComponent"
                    @filter="getGraphDashboard"
                    :dashboardTab="dashboardTab"
                    :isAdmin="isAdmin"
                    :organizations="organizations"
                    filterFor="entityChart"
                    @initialTypeSetted="getGraphDashboard"
                />
            </h4>
            <template v-if="dashboardGraph[0]">
                <div v-if="dashboardGraph[0].results[0]" class="chart-wrapper">
                    <div
                        class="chart"
                        v-if="
                            dashboardGraph[0].results.length > 0 ||
                            dashboardGraph[1].results.length > 0
                        "
                    >
                        <apexchart
                            type="area"
                            width="100%"
                            height="300"
                            :options="chartOptions"
                            :series="series"
                        />
                    </div>
                </div>
                <div v-else>
                    <div class="alert info">
                        <vs-icon icon="info" />
                        No existe suficiente información para mostrar la
                        comparación de ofertas.
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import DashboardFilters from "./DashboardFilters.vue";
import VueApexCharts from "vue-apexcharts";
import gql from "graphql-tag";
import axios from "axios";
import { print } from "graphql";

const graphDashboard = gql`
    query graphDashboard(
        $currentUserToken: String!
        $scope: String!
        $scopedOrganizationId: Int
        $filters: DashboardFilterInput
    ) {
        graphDashboard(
            currentUserToken: $currentUserToken
            scope: $scope
            scopedOrganizationId: $scopedOrganizationId
            filters: $filters
        ) {
            name
            results {
                day
                value
            }
        }
    }
`;

export default {
    name: "chart-dashoard",
    components: {
        DashboardFilters,
        apexchart: VueApexCharts,
    },
    props: {
        dashboardTab: {
            type: String,
            required: true,
        },
        isAdmin: {
            type: Boolean,
            required: false,
            default: false,
        },
        organizations: {
            type: Array,
            required: false,
            default: [],
        },
        scopedOrganizationId: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            dashboardGraph: {},
            lastUserTypeUsed: "",
            series: [
                {
                    name: "Ofertado",
                    data: [],
                },
                {
                    name: "Concretado",
                    data: [],
                },
            ],
            chartOptions: {
                chart: {
                    height: 350,
                    zoom: {
                        enabled: false,
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                stroke: {
                    curve: "smooth",
                },
                grid: {
                    row: {
                        colors: ["#f3f3f3", "transparent"],
                        opacity: 0.5,
                    },
                },
                xaxis: {
                    categories: [],
                },
            },
        };
    },
    mounted() {
        this.$watch(
            "$refs.filtersComponent.filter.type",
            (new_value, old_value) => {
                this.getGraphDashboard();
            }
        );
    },
    watch: {
        dashboardGraph() {
            this.getOfferedData();
            this.getFinishedData();
        },
        scopedOrganizationId() {
            this.getGraphDashboard();
        },
    },
    methods: {
        getGraphDashboard() {
            var orgId =
                this.isAdmin && this.scopedOrganizationId
                    ? { scopedOrganizationId: this.scopedOrganizationId }
                    : {};
            var filter = this.$refs.filtersComponent;

            // Esto es un parche porque el filtro no trae bien si es tipo compra o venta.
            let userFilterType;
            if (!filter.filter.type) {
                userFilterType = this.lastUserTypeUsed;
            } else {
                this.lastUserTypeUsed = filter.filter.type;
                userFilterType = this.lastUserTypeUsed;
            }

            delete this.$refs.filtersComponent.filter.category; //Se elimina el objeto category para que no realice ninguna modificacion en el dash de entity
            axios
                .get(`${process.env.VUE_APP_GRAPH_PATH}`, {
                    params: {
                        query: print(graphDashboard),
                        variables: Object.assign(
                            {
                                currentUserToken:
                                    localStorage.getItem("USER_TOKEN"),
                                scope: this.dashboardTab,
                                filters: {
                                    weekFrom: filter.invertedWeekFrom,
                                    weekTo: filter.invertedWeekTo,
                                    type: userFilterType,
                                },
                            },
                            orgId
                        ),
                    },
                })
                .then((res) => {
                    if (!res.data.errors) {
                        this.dashboardGraph = res.data.data.graphDashboard;
                    }
                })
                .catch((err) => {});
        },
        getOfferedData() {
            var dGraph = this.dashboardGraph
                ? this.dashboardGraph.find((a) => a.name == "Ofertado")
                : [];
            this.series.find((e) => e.name == "Ofertado").data = dGraph
                ? dGraph.results.map((e) => Number(e.value))
                : [];
            let dateArr = dGraph ? dGraph.results.map((e) => e.day) : [];
            this.chartOptions = {
                ...this.chartOptions,
                ...{ xaxis: { categories: dateArr } },
            };
        },
        getFinishedData() {
            this.series.find((e) => e.name == "Concretado").data =
                this.dashboardGraph
                    .find((a) => a.name == "Concretado")
                    .results.map((e) => Number(e.value));
        },
        filterByUser(type) {
            this.$refs.filtersComponent.changeType(type);
        },
    },
};
</script>

